import { Box, Divider, VStack, Card } from "@chakra-ui/react";
import { Heading, Text } from "@equidefi/ui";
import { CurrencyFormatter } from "@/constants/format";
import { formatSecurities, offeringHidesSecurityLabel, offeringInvestorMinimumUnits } from "@equidefi/shared";

export const OfferingInfoCard = ({ offering }) => {
  if (!offering) return null;

  const sharePrice = offering.unit_price ?? 1;
  const minShares = offeringInvestorMinimumUnits(offering);
  const minInvestment = minShares * sharePrice;
  const hideSecurityLabel = offeringHidesSecurityLabel(offering);

  return (
    <Card p={4} my={3}>
      <VStack align="start" spacing={1}>
        <Text fontSize="sm" mb={0}>
          You're Investing In
        </Text>

        <Heading as="h2" size="lg" fontWeight="bold" mb={0}>
          {offering.issuer?.name}
        </Heading>

        <Text fontSize="md" mb={0} fontWeight="bold">
          {offering.name}
        </Text>

        <Divider borderColor="gray.300" my={2} />

        <Box w="full">
          {!hideSecurityLabel && (
            <Text fontSize="sm" mb={0}>
              <Text as="span" fontWeight="bold" fontSize="sm">
                {offering.security_type_label} Price:
              </Text>{" "}
              {CurrencyFormatter.format(sharePrice)}
            </Text>
          )}
          <Text fontSize="sm" mb={0}>
            <Text as="span" fontWeight="bold" fontSize="sm">
              Minimum Investment:
            </Text>{" "}
            {CurrencyFormatter.format(minInvestment)}
            {!hideSecurityLabel && ` (${formatSecurities({ offering, quantity: minShares }).toString()})`}
          </Text>
        </Box>
      </VStack>
    </Card>
  );
};
